import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const AboutSection = () => {
  return (
    <section id="about" className="py-16 sm:py-20 md:py-24 bg-[#0B1C2C] relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-0 w-64 sm:w-96 h-64 sm:h-96 bg-[#D4AF37]/[0.08] rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-0 w-64 sm:w-96 h-64 sm:h-96 bg-[#D4AF37]/[0.05] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 items-center">
          {/* Image Side */}
          <div className="relative group order-2 lg:order-1" data-testid="about-image">
            <div className="absolute inset-0 bg-[#D4AF37]/30 rounded-2xl blur-2xl opacity-20 group-hover:opacity-30 transition-opacity duration-500"></div>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/10">
              <img
                src="/about_section.jpg"
                alt="Aviation Excellence"
                className="w-full h-[300px] sm:h-[400px] md:h-[500px] object-cover transform group-hover:scale-[1.03] transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1C2C] via-transparent to-transparent"></div>
            </div>
          </div>

          {/* Content Side */}
          <div className="space-y-5 sm:space-y-6 order-1 lg:order-2">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white tracking-tight">
              About <span className="text-[#D4AF37]" style={{textShadow: '0 0 30px rgba(212,175,55,0.3)'}}>Turbowing Aviation</span>
            </h2>

            <div className="space-y-4 text-white/75 leading-relaxed">
              <p className="text-base sm:text-lg">
                Turbowing Aviation is a trusted partner in the global aviation supply chain, specializing in the sourcing and distribution of aircraft spare parts and components.
              </p>

              <p className="text-base sm:text-lg">
                With a commitment to quality, reliability, and customer satisfaction, we serve aviation operators, maintenance facilities, and airlines worldwide.
              </p>

              <p className="text-base sm:text-lg">
                Our extensive supplier network and industry expertise enable us to provide fast, efficient solutions for your aircraft component needs, ensuring minimal downtime and maximum operational efficiency.
              </p>
            </div>

            <div className="pt-4 sm:pt-6">
              <a href="/contact" className="inline-block w-full sm:w-auto" data-testid="about-cta-learn">
                <Button className="w-full sm:w-auto bg-[#D4AF37] hover:bg-[#e5c04d] text-[#0B1C2C] font-bold px-8 py-6 text-sm uppercase tracking-wider rounded-sm transition-all duration-500 hover:shadow-[0_0_30px_rgba(212,175,55,0.45)] hover:-translate-y-0.5 group cursor-pointer">
                  Learn More About Us
                  <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform duration-500" />
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
